﻿import { create } from 'zustand';

interface FavoriteState {
  favorites: string[],
  // eslint-disable-next-line no-unused-vars
  add: (id: string) => void
  // eslint-disable-next-line no-unused-vars
  remove: (id: string) => void
  // eslint-disable-next-line no-unused-vars
  setInitial: (ids: string[]) => void
}

const useFavoriteStore = create<FavoriteState>()((set) => ({
  favorites: [],

  add: (id) =>
    set((state) => {
      if (state.favorites.includes(id)) return state;
      const newFavorites = [...state.favorites];
      newFavorites.unshift(id);
      return {
        favorites: newFavorites
      };
    }),

  setInitial: (ids) =>
    set(() =>
      ({ favorites: ids })),

  remove: (id) =>
    set((state) =>
      ({ favorites: state.favorites.filter((fav) => fav !== id) }))
}));

export default useFavoriteStore;